import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import {
  validatePresence,
  validateFormat,
} from 'ember-changeset-validations/validators';

const customerQuestionValidation = {
  text: validatePresence({ presence: true, message: "Can't be blank" }),
};
const demoQuestionValidation = {
  name: validatePresence({ presence: true, message: "Can't be blank" }),
  email: validateFormat({
    type: 'email',
    message: 'Not a valid email address',
  }),
  text: validatePresence({ presence: true, message: "Can't be blank" }),
};

export default Route.extend({
  fundsService: service(),
  navbarSettings: service(),
  currentUser: service(),
  store: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Ask a Question');
    return this.fundsService.confirmValidFundToken();
  },

  model() {
    let validation = get(this, 'currentUser.isDemoUser')
      ? demoQuestionValidation
      : customerQuestionValidation;

    let record = this.store.createRecord('question');
    return {
      record: record,
      changeset: new Changeset(record, lookupValidator(validation), validation),
    };
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
